/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Searchplaceholder3Inputs */

const en_settings_reportingapikeys_searchplaceholder3 = /** @type {(inputs: Settings_Reportingapikeys_Searchplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search by key name, user, or organization`)
};

/**
* | output |
* | --- |
* | "Search by key name, user, or organization" |
*
* @param {Settings_Reportingapikeys_Searchplaceholder3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_searchplaceholder3 = /** @type {((inputs?: Settings_Reportingapikeys_Searchplaceholder3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Searchplaceholder3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_searchplaceholder3(inputs)
});
export { settings_reportingapikeys_searchplaceholder3 as "settings_reportingApiKeys_searchPlaceholder" }